import { ButtonBase, styled } from '@mui/material';

/**
 * A bordered button for an action on a viewport overlay, as a plain text link
 * is not recognised as actionable. A toggle shows its on state by
 * `aria-pressed`.
 */
export const OverlayActionButton = styled(ButtonBase)(({ theme }) => ({
    pointerEvents: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    padding: theme.spacing(0.5, 0.75),
    borderRadius: `${theme.shape.borderRadius}px`,
    border: '1px solid rgba(255, 255, 255, 0.4)',
    color: theme.palette.common.white,
    '&:hover, &[aria-pressed="true"]': {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
    },
    '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: 1,
    },
}));
